import { render, staticRenderFns } from "./SalesListFooter.vue?vue&type=template&id=004ac64b"
import script from "./SalesListFooter.vue?vue&type=script&lang=js"
export * from "./SalesListFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports